export enum Language {
  NL = 'nl',
  EN = 'en',
}

// Add languages use JSON files with {"nl": "Jouw tekst", "en": Your text}
export const supportedLang = [Language.NL, Language.EN];
